export interface CookiesPageData {}

export interface CookiesPageProps extends CookiesPageData {}
